import { render } from "./BotonLevantamientoEmbargoGobernacionComponent.vue?vue&type=template&id=2b85e1b1"
import script from "./BotonLevantamientoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./BotonLevantamientoEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__